import React from 'react';
import { Button, Grid2 as Grid, Typography } from '@mui/material';
import { RefreshRounded, SignalWifiConnectedNoInternet4Rounded } from '@mui/icons-material';

const RetryView = ({
    onRetry,
    message = "خطا در برقراری ارتباط با سرور",
    buttonText = "تلاش مجدد",
    height = "70vh"
}) => {
    return (
        <Grid
            container
            sx={{ width: "100%", height, px: 2 }}
            direction="column"
            justifyContent="center"
            alignItems="center"
        >
            <SignalWifiConnectedNoInternet4Rounded
                sx={{
                    fontSize: "4rem",
                    color: "text.secondary",
                    mb: 1.5,
                    opacity: 0.8
                }}
            />
            <Typography
                variant="body1"
                sx={{
                    fontFamily: "IRANSans-web, Tahoma, sans-serif",
                    color: "text.primary",
                    fontWeight: 600,
                    textAlign: "center",
                    maxWidth: 380,
                    mb: 2.5,
                    lineHeight: 1.7
                }}
            >
                {message}
            </Typography>
            {onRetry && (
                <Button
                    variant="contained"
                    color="primary"
                    onClick={onRetry}
                    startIcon={<RefreshRounded />}
                    sx={{
                        fontFamily: "IRANSans-web, Tahoma, sans-serif",
                        borderRadius: 3,
                        px: 3,
                        py: 1,
                        fontWeight: 600,
                        boxShadow: "0 4px 14px rgba(231, 51, 62, 0.35)",
                        bgcolor: "#e7333e",
                        "&:hover": { bgcolor: "#c70813" }
                    }}
                >
                    {buttonText}
                </Button>
            )}
        </Grid>
    );
};

export default RetryView;
